import type { CustomPage } from '../types/AcademyAdminPages.model';
import { useQuery } from '@tanstack/react-query';
import FetchPromise from '~/agent/fetch-promise';
import { academyCustomPagesKeys } from '../utils';

const getCustomPages = (academyId: string) => FetchPromise.get(`academies/${academyId}/academy_custom_pages`);

export function useGetCustomPages(academyId: string) {
  return useQuery<CustomPage[]>(academyCustomPagesKeys.academyCustomPages(academyId), () => getCustomPages(academyId));
}
